import { defineAsyncComponent } from "vue";
export default [
  {
    name: "AssignmentMonitor",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/monitoring/Monitoring"),
    ),
    path: "",
    props: (route) => ({ query: route.query }),
  },
  {
    name: "AssignmentMonitorAggregateAttemptView",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/aggregate-attempt/AggregateAttempt"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:activityId/component/:componentId/question/:questionUuid/aggregate-attempt",
    props: true,
  },
  {
    name: "AssignmentMonitorAggregateQuizAttempt",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/aggregate-attempt/AggregateQuizAttempt.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/aggregate-attempt",
    props: true,
  },
  {
    name: "AssignmentMonitorAbilitySnapshot",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/monitoring/AdaptiveSectionMonitoring.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/ability-snapshot",
    props: true,
  },
];
